import React, { useEffect, useRef, useState } from "react";
import { UseFormReturn } from "react-hook-form/dist/types";

import { BriefHeader } from "../../../features/brief-header/components/brief-header/brief-header.component";
import { ContentWrapper, PageWrapper } from "../../../features/layout/components/layout.styles";
import { HEADER_MIN_HEIGHT } from "../../../utils/constants";

import { withShowIf } from "../../with-show-if/with-show-If.component";

import { BriefErrorMessage } from "../BriefErrorMessage";
import { BriefLoader } from "../BriefLoader";
import { BriefFormWrapper } from "../brief-form-wrapper/brief-form-wrapper.component";

import { BriefWrapperProps } from "./brief-wrapper.props";

interface FormRef extends UseFormReturn<any> {
  isDirty: boolean;
}

export const BriefWrapper = withShowIf((props: BriefWrapperProps) => {
  const { briefId, defaultValues, isLoading, setIsSaving } = props;
  const [headerHeight, setHeaderHeight] = useState(HEADER_MIN_HEIGHT);
  const formRef = useRef<Partial<FormRef>>({ isDirty: false });

  const [loaded, setLoaded] = useState<boolean>(false);
  const [forceOpen, setForceOpen] = useState<false | (() => any)>(false);
  const [currentTabValue, setCurrentTabValue] = useState(0);

  const shouldChangeTab = (newTabValue: number, changeTab: () => void) => {
    if (formRef.current.isDirty && currentTabValue === 0) {
      setForceOpen(() => (response: boolean) => {
        setForceOpen(false);

        if (response) {
          changeTab();
        }
      });

      return false;
    }

    return true;
  };

  const handleTabChange = (newValue: number) => {
    setCurrentTabValue(newValue);
    formRef.current.reset && formRef.current.reset();
  };

  useEffect(() => {
    if (briefId > 0) {
      formRef.current.reset && formRef.current.reset(defaultValues);
    }
  }, [briefId, defaultValues]);

  useEffect(() => {
    setLoaded(isLoading.status === "loaded" || isLoading.status === "failed");

    if (isLoading.status !== "loading") {
      setIsSaving(false);
    }
  }, [setLoaded, setIsSaving, isLoading]);

  const hasErrors = () => Boolean(props.stateErrors);

  return (
    <PageWrapper>
      <BriefHeader
        breadcrumbInfo={props.breadcrumbInfo}
        briefId={briefId}
        briefName={props.name}
        briefOwner={props.owner}
        briefTemplate={props.template}
        briefType={props.briefType}
        currentTabValue={currentTabValue}
        extraActions={props.extraActions}
        formRef={formRef}
        hasErrors={hasErrors()}
        loaded={loaded}
        onChangeName={props.onChangeName}
        onSubmit={props.onSubmit}
        setHeaderHeight={setHeaderHeight}
        showIf={Boolean(formRef)}
        status={props.status}
        updatedTime={props.updatedTime}
      />
      <ContentWrapper>
        <BriefErrorMessage showIf={hasErrors()} errors={props.stateErrors!} />
        <BriefLoader showIf={!loaded} />
        <BriefFormWrapper
          ContentComponent={props.ContentComponent}
          currentTabValue={currentTabValue}
          attachedFiles={props.attachedFiles}
          defaultValues={defaultValues}
          forceOpen={forceOpen}
          formErrors={props.formErrors}
          formRef={formRef}
          shouldChangeTab={shouldChangeTab}
          handleTabChange={handleTabChange}
          headerHeight={headerHeight}
          ndaData={props.ndaData}
          onDeleteFile={props.onDeleteFile}
          onUploadFile={props.onUploadFile}
          resourceId={briefId}
          showIf={loaded && !hasErrors()}
          status={props.status}
          template={props.template}
          validationSchema={props.validationSchema}
        />
      </ContentWrapper>
    </PageWrapper>
  );
});
